<template lang="pug">
loading-wrapper(:loading="isLoading" size="2xl")
  template(v-if="topicList.length")
    .tg-chat-topics-list
      ds-panel(
        v-for="topic in topicList"
        :key="topic.id"
        space="sm"
        class="tg-chat-topic-item-panel"
      )
        ds-panel-element(offset="vertical")
          ds-link.tg-chat-topic-item(
            appearance="block"
            :class="{ 'is-active': isActiveTopic(topic) }"
            @click.prevent="selectTopic(topic)"
          )
            .tg-chat-topic-item__header
              ds-caption(variant="strong") {{ getTopicTitle(topic) }}

              span.tg-chat-unread-badge(
                v-if="getTopicUnreadCount(topic)"
              ) {{ getTopicUnreadCount(topic) }}

            ds-caption(
              v-if="getTopicLastMessageAt(topic)"
              size="sm"
            )
              | {{ _('Последнее сообщение') }}:
              |  {{ getTopicLastMessageAt(topic) }}

            ds-caption(
              v-if="isTopicClosed(topic)"
              size="sm"
              class="tg-chat-topic-item__closed"
            ) {{ _('Топик закрыт') }}

  template(v-else)
    ds-panel
      ds-panel-element(offset="vertical")
        ds-caption(size="sm")
          | {{ _('В этой форумной группе нет топиков.') }}
</template>

<script>
import { tgChatApi } from '@md/tg-chat/api'

export default {
  name: 'TelegramChatTopics',

  props: {
    chat: {
      type: Object,
      default: null,
    },
    activeTopic: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
      topicList: [],
    }
  },

  watch: {
    'chat.id': {
      immediate: true,
      async handler(newId, oldId) {
        if (newId !== oldId) {
          await this.receiveTopics()
        }
      },
    },
  },

  methods: {
    extractListItems(response) {
      if (Array.isArray(response)) {
        return response
      }

      if (Array.isArray(response?.data?.items)) {
        return response.data.items
      }

      if (Array.isArray(response?.items)) {
        return response.items
      }

      if (Array.isArray(response?.results)) {
        return response.results
      }

      return []
    },

    async receiveTopics() {
      if (!(this.chat && this.chat.id)) {
        this.topicList = []
        return
      }

      this.isLoading = true

      try {
        const response = await tgChatApi.topics.list.execute({
          chatId: this.chat.id,
        })

        this.topicList = this.extractListItems(response)
      } catch (error) {
        this.topicList = []

        this.$toast.error(
          this._('Не удалось загрузить топики Telegram.')
        )
      } finally {
        this.isLoading = false
      }
    },

    selectTopic(topic) {
      this.$emit('select', topic)
    },

    isActiveTopic(topic) {
      return !!(
        this.activeTopic
        && topic
        && String(this.activeTopic.id) === String(topic.id)
      )
    },

    getTopicTitle(topic) {
      return (
        topic?.title
        || `${this._('Топик')} #${topic?.tgTopicId || topic?.tg_topic_id || topic?.id}`
      )
    },

    getTopicUnreadCount(topic) {
      const value = Number(
        topic?.unreadCount
        || topic?.unread_count
        || 0
      )

      return Number.isFinite(value) && value > 0
        ? value
        : 0
    },

    getTopicLastMessageAt(topic) {
      const value = (
        topic?.lastMessageAt
        || topic?.last_message_at
      )

      return value
        ? this.$d(new Date(value), 'datetime')
        : ''
    },

    isTopicClosed(topic) {
      return !!(
        topic?.isClosed
        || topic?.is_closed
      )
    },
  },
}
</script>